import { t, AVAILABLE_LOCALES, type LandingLocale } from '../i18n/I18n.js';
import { escapeAttr } from '../html.js';

function localeHref(code: LandingLocale): string {
  return code === 'en' ? '/' : `/${code}/`;
}

function langSelector(locale: LandingLocale): string {
  const currentLabel = t(`language.${locale}` as const);
  const items = AVAILABLE_LOCALES.map((code) => {
    const current = code === locale ? ' aria-current="page"' : '';
    return `<li><a href="${localeHref(code)}"${current}>${t(`language.${code}` as const)}</a></li>`;
  }).join('');
  return `
    <details class="lang-select">
      <summary aria-label="${escapeAttr(t('language.toggleLabel'))}">${currentLabel}</summary>
      <ul class="lang-menu">
        ${items}
      </ul>
    </details>
  `;
}

function footerLangLinks(locale: LandingLocale): string {
  const links = AVAILABLE_LOCALES.map((code) => {
    const current = code === locale ? ' aria-current="page"' : '';
    return `<a href="${localeHref(code)}"${current}>${t(`language.${code}` as const)}</a>`;
  }).join('');
  return `
    <nav class="footer-lang" aria-label="${escapeAttr(t('language.toggleLabel'))}">
      ${links}
    </nav>
  `;
}

function footerLegalLinks(): string {
  return `
    <nav class="footer-legal" aria-label="${escapeAttr(t('footer.legalNav'))}">
      <a href="/privacy">${t('footer.privacy')}</a>
      <a href="/terms">${t('footer.terms')}</a>
    </nav>
  `;
}

export function renderHeader(locale: LandingLocale): string {
  return `
    <header class="site-header">
      <a class="brand" href="${localeHref(locale)}">
        <img class="brand-mark" src="/logo.svg" alt="${escapeAttr(t('app.name'))}" width="48" height="48" />
      </a>
      <nav class="site-nav" aria-label="Primary">
        <a href="#games">${t('nav.games')}</a>
        <a href="#about">${t('nav.about')}</a>
        <a href="#changelog">${t('nav.changelog')}</a>
      </nav>
      <div class="header-auth"></div>
      ${langSelector(locale)}
    </header>
  `;
}

export function renderFooter(locale: LandingLocale): string {
  const year = new Date().getFullYear();
  return `
    <footer class="site-footer">
      <span class="footer-line">${t('footer.yearLine', { year })}</span>
      ${footerLegalLinks()}
      ${footerLangLinks(locale)}
    </footer>
  `;
}
